/*** IMPORTS FROM imports-loader ***/
var windowTemp = window;

if(!global["window"]) global["window"] = {};
module.exports = global["window"]["$"] = require("-!D:\\a\\1\\s\\HowNow.Portal.Website\\node_modules\\expose-loader\\index.js?window.jQuery!.\\jquery.js");
